import PageHeading from "Layout/AppMain/PageHeading";
import React, { Fragment, useEffect, useState } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Card, CardBody, CardFooter, CardHeader, Col, Row, Button } from "reactstrap";
import { Table } from "reactstrap";
import Tippy from "@tippyjs/react";
import { BsCheckCircle, BsQuestionCircle } from "react-icons/bs";
import { ReactComponent as Football } from "../../../../assets/utils/images/svgs/Football.svg";
import InformationBlue from "../../../../assets/utils/images/svgs/InformationBlue.svg";
import moment from "moment";
import { Link } from "react-router-dom";
import Loader from "react-loaders";
import TextLimit from "Api/TextLimit";
import VervangerService from "Api/Vervanger";
import useSWR from "swr";
import {useNavigate } from "react-router-dom";


const Default = () => {
    const [planboardData, setPlanboardData] = useState([]);
    const [mainLoader, setMainLoader] = useState(false);
    const [schools, setSchools] = useState([]);
    const [schoolArray, setSchoolArray] = useState([]);
    const [weeks, setWeeks] = useState([]);
    const [sumOfWeeks, setSumOfWeeks] = useState(4);
    const [showLoader, setShowLoader] = useState(false);

    const navigate = useNavigate();
    const MIDDAG_FIRST_CELL = 9;

    const handleRowClick = (e, rowData) => {

        if (e.target.closest("a, button, input, select, textarea")) return;

        const cell = e.target.closest("td");
        if (!cell) return;

        const part = cell.cellIndex >= MIDDAG_FIRST_CELL ? "Middag" : "Ochtend";
        const id = rowData?.[part]?.id;
        if (id) navigate(`/home/${id}`);
    };

    const {
        data: substitutionResponse,
        isLoading: substitutionsLoading,
    } = useSWR(
        "substitutions",
        () => VervangerService.getSubstitutions()
    );

    const substitutorData =
        substitutionResponse?.data?.date?.substitutions || [];

    const firstDayAssigned =
        substitutionResponse?.data?.date?.firstDayAssigned || "";

    useEffect(() => {
        getSubstitutionData(0);
    }, []);

    const getSubstitutionData = (increment) => {
        setShowLoader(true);
        let unique = [];
        let uniqueWeek = [];
        let num = parseInt(sumOfWeeks) + increment;
        VervangerService.getPlanboard(num).then((response) => {
            if (response.status != undefined && response.status == 200) {
                if (response.data.date.planBoard !== undefined) {
                    setShowLoader(false);
                    setPlanboardData(response.data.date.planBoard);
                }

                let array = response.data.date.planBoard
                Object.keys(array).map((key, index) => {
                    let week = array[key].weekNumber;
                    weeks.push(week)
                    if (array[key]['Ochtend'].schoolId !== undefined) {
                        let id = array[key]['Ochtend'].schoolId
                        schoolArray.push(id);
                    }
                    if (array[key]['Middag'].schoolId !== undefined) {
                        let id = array[key]['Middag'].schoolId
                        schoolArray.push(id);
                    }
                })
                unique = schoolArray.filter(onlyUnique);
                uniqueWeek = weeks.filter(onlyUnique);

                setSumOfWeeks(uniqueWeek.length);
                setSchools(unique);
            }
        }).catch(() => console.error);
    }

    function onlyUnique(value, index, array) {
        return array.indexOf(value) === index;
    }


    const iconSwitch = (param) => {
        switch (param) {
            case 'Aangevraagd':
                return <Tippy content={param} placement="bottom"><span><BsQuestionCircle color='#F2983E' fontSize={"18px"} /></span></Tippy>;
            case 'Ingepland':
                return <Tippy content={param} placement="bottom"><span><BsCheckCircle color='#39A825' fontSize={"21px"} /></span></Tippy>;
            default:
                return '';
        }
    }

    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad>
                <div>
                    <Row className="home-table-styling">
                        <Col md="12" sm="12" lg="12" xxl="8" className="w-70 table-1">
                            <Card className="main-card mb-3">
                                <CardBody className="p-3">
                                    {substitutionsLoading ? <>
                                        <Loader type="ball-grid-pulse" className={'mt-3 d-flex mx-auto justify-content-center'} />
                                    </> : <>
                                        {planboardData.length === 0 ?
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div class="text-center">Geen data beschikbaar</div>
                                                </div>
                                            </div>
                                            : (
                                                <Table size="sm" borderless className="mb-0 subs-main-table table-background hidden-row-style">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-left">Week</th>
                                                            <th className="text-center">Datum</th>

                                                            <th colSpan="2">Ochtend</th>
                                                            <th className={"text-center"}>Bestuur</th>
                                                            <th className={'text-center'}>Status</th>
                                                            <th className={"text-center"}>Gym</th>
                                                            <th className={"text-center"}>Opm</th>

                                                            <th>&nbsp;</th>

                                                            <th colSpan="2">Middag</th>
                                                            <th className={"text-center"}>Bestuur</th>
                                                            <th className={'text-center'}>Status</th>
                                                            <th className={"text-center"}>Gym</th>
                                                            <th className={"text-center"}>Opm</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="table-left-border table-right-border ">
                                                        {planboardData !== undefined && Object.keys(planboardData).map((key, index) => (

                                                            <tr
                                                                key={key}
                                                                onClick={(e) => handleRowClick(e, planboardData[key])}
                                                                className={
                                                                    (index % 5 == 0 ? "custom-border-top " : "") +
                                                                    " row-clickable varvanger_row_color-" +
                                                                    (parseInt(Object.keys(schools).find((key1) => schools[key1] === planboardData[key]['Ochtend'].schoolId)) + 1)
                                                                }
                                                            >                                                                <td className="table-right-border">{index % 5 == 0 ? planboardData[key].weekNumber : ''}</td>
                                                                <td className="table-right-border text-center">{new Date(moment(key, 'DD-MM-YYYY')).toLocaleDateString("nl-NL", { weekday: 'short' })} {key}</td>
                                                                <>
                                                                    <td className={'custom-border-left vervanger-cell-style'}>
                                                                        {planboardData[key]['Ochtend'].status !== 'Geannuleerd' && (
                                                                            <Link
                                                                                to={`/home/${planboardData[key]['Ochtend'].id}`}
                                                                                key={'id'}
                                                                            >
                                                                                {
                                                                                    window.innerWidth > 1250 ?
                                                                                        TextLimit.limitStringLargeScreen(planboardData[key]['Ochtend'].label)
                                                                                        : TextLimit.limitStringSmallScreen(planboardData[key]['Ochtend'].label)
                                                                                }
                                                                            </Link>
                                                                        )}
                                                                    </td>
                                                                    <td className={'vervanger-cell-style'}>&nbsp;</td>
                                                                    <td className={'vervanger-cell-style text-center'}>
                                                                        {planboardData[key]['Ochtend'].status !== 'Geannuleerd' && (
                                                                            <Link
                                                                                to={`/home/${planboardData[key]['Ochtend'].id}`}
                                                                                key={'id'}
                                                                            >
                                                                                {TextLimit.limitStringSmallScreen(planboardData[key]['Ochtend'].organisation)}
                                                                            </Link>
                                                                        )}
                                                                    </td>
                                                                    <td className={"text-center"}>
                                                                        <Link
                                                                            to={`/home/${planboardData[key]['Ochtend'].id}`}
                                                                            key={'id'}
                                                                        >
                                                                            {iconSwitch(planboardData[key]['Ochtend'].status)}
                                                                        </Link>
                                                                    </td>
                                                                    <td className={"text-center football-icon-style-home"}>
                                                                        <Link
                                                                            to={`/home/${planboardData[key]['Ochtend'].id}`}
                                                                            key={'id'}
                                                                        >
                                                                            {planboardData[key]['Ochtend'].gym == true && <Football />}
                                                                        </Link>
                                                                    </td>
                                                                    <td className={"text-center"}>
                                                                        <Link
                                                                            to={`/home/${planboardData[key]['Ochtend'].id}`}
                                                                            key={'id'}
                                                                        >
                                                                            {planboardData[key]['Ochtend'].note == true && <span><img src={InformationBlue} /></span>}
                                                                        </Link>
                                                                    </td>
                                                                </>

                                                                <td className="table-right-border">&nbsp;</td>
                                                                <>
                                                                    <td className={'custom-border-left vervanger-cell-style'}>
                                                                        {planboardData[key]['Middag'].status !== 'Geannuleerd' && (
                                                                            <Link
                                                                                to={`/home/${planboardData[key]['Middag'].id}`}
                                                                                key={'id'}
                                                                            >
                                                                                {
                                                                                    window.innerWidth > 1250 ?
                                                                                        TextLimit.limitStringLargeScreen(planboardData[key]['Middag'].label)
                                                                                        : TextLimit.limitStringSmallScreen(planboardData[key]['Middag'].label)
                                                                                }
                                                                            </Link>
                                                                        )}
                                                                    </td>
                                                                    <td className={'vervanger-cell-style'}></td>
                                                                    <td className={'vervanger-cell-style text-center'}>
                                                                        {planboardData[key]['Middag'].status !== 'Geannuleerd' && (
                                                                            <Link
                                                                                to={`/home/${planboardData[key]['Middag'].id}`}
                                                                                key={'id'}
                                                                            >
                                                                                {TextLimit.limitStringSmallScreen(planboardData[key]['Middag'].organisation)}
                                                                            </Link>
                                                                        )}
                                                                    </td>
                                                                    <td className={"text-center"}>
                                                                        <Link
                                                                            to={`/home/${planboardData[key]['Middag'].id}`}
                                                                            key={'id'}
                                                                        >
                                                                            {iconSwitch(planboardData[key]['Middag'].status != undefined && planboardData[key]['Middag'].status)}
                                                                        </Link>
                                                                    </td>
                                                                    <td className={"text-center football-icon-style-home"}>
                                                                        <Link
                                                                            to={`/home/${planboardData[key]['Middag'].id}`}
                                                                            key={'id'}
                                                                        >
                                                                            {planboardData[key]['Middag'].gym == true && <Football />}
                                                                        </Link>
                                                                    </td>
                                                                    <td className={"text-center"}>
                                                                        <Link
                                                                            to={`/home/${planboardData[key]['Middag'].id}`}
                                                                            key={'id'}
                                                                        >
                                                                            {planboardData[key]['Middag'].note == true && <span><img src={InformationBlue} /></span>}
                                                                        </Link>
                                                                    </td>
                                                                </>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            )}

                                        {
                                            showLoader === false &&
                                            <Button color="link" className="btn-color-style mt-3 d-flex mx-auto" onClick={() => getSubstitutionData(4)} >
                                                <div className="mt-2">

                                                    Meer
                                                </div>
                                            </Button>
                                        }

                                        {
                                            planboardData.length !== 0 && showLoader === true &&
                                            <Loader type="ball-grid-pulse" className={'mt-3 d-flex mx-auto justify-content-center'} />
                                        }
                                    </>
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md="12" sm="12" lg="12" xxl="4">
                            {substitutionsLoading ? <Card className="main-card mb-3 table-2">
                                <CardBody>
                                    <Loader type="ball-grid-pulse" className={'mt-3 d-flex mx-auto justify-content-center'} />
                                </CardBody>
                            </Card> : <>
                                <Card className="main-card mb-3 table-2">
                                    <CardHeader className="row m-0 no-text-transform ">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <span className="col-md-12 ps-0 head-text-color menu-header-title planbord">
                                                    <span>Eerstvolgende werkdag</span>
                                                </span>
                                            </div>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Table size="sm" borderless className="mb-0 subs-main-table">
                                            <tbody>
                                                <tr>
                                                    <th>Datum</th>
                                                    {firstDayAssigned !== '' ? <td className={"custom-td"}>{moment(firstDayAssigned).format('DD-MM-yyyy')}</td> : <td className="custom-td text-center">Geen eerstvolgende werkdag</td>}
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </CardBody>
                                </Card>
                                <Card className="main-card mb-3 table-2">
                                    <CardHeader className="row m-0 no-text-transform ">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <span className="col-md-12 ps-0 head-text-color menu-header-title planbord">
                                                    <span>Aangevraagde verzoeken</span>
                                                </span>
                                            </div>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Table size="sm" borderless className="mb-0 subs-main-table">
                                            <thead>
                                                <tr>
                                                    <th>Verzoek</th>
                                                    <th>School</th>
                                                    <th>1e Dag</th>
                                                    <th>Dagdelen</th>
                                                </tr>

                                            </thead>
                                            <tbody>
                                                {substitutorData?.length > 0 ? substitutorData.map((block, i) => {
                                                    return (<tr className="border-bottom-0">
                                                        <td>
                                                            <Link
                                                                to={`/home/${block.id}`}
                                                                key={'id'}
                                                            >
                                                                {block.id}
                                                            </Link>
                                                        </td>
                                                        <td>
                                                            <Link
                                                                to={`/home/${block.id}`}
                                                                key={'id'}
                                                            >
                                                                {
                                                                    window.innerWidth > 1250 ?
                                                                        TextLimit.limitStringLargeScreen(block.school.name)
                                                                        : TextLimit.limitStringSmallScreen(block.school.name)
                                                                }
                                                            </Link>

                                                        </td>
                                                        <td>
                                                            <Link
                                                                to={`/home/${block.id}`}
                                                                key={'id'}
                                                            >
                                                                {block.firstDayRequested}
                                                            </Link>
                                                        </td>
                                                        <td>
                                                            <Link
                                                                to={`/home/${block.id}`}
                                                                key={'id'}
                                                            >
                                                                {block.daysRequested}
                                                            </Link>
                                                        </td>
                                                    </tr>)
                                                })
                                                    : <tr><td colSpan={4} className="text-center">Geen aangevraagde verzoeken</td></tr>}
                                            </tbody>
                                        </Table>
                                    </CardBody>
                                </Card>
                            </>}
                        </Col>
                    </Row>
                </div>
            </TransitionOnLoad>

        </Fragment>
    )
};

export default Default;